<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / <a href="/integrations/catalogue">Integrations</a> /
      <span> Sign in to Redtail </span>
    </nav>
    <integrations-loading v-if="loading"></integrations-loading>
    <div class="integrations-auth-redtail" v-else>
      <h2 class="integrations-auth-redtail__heading">Sign in to Redtail to connect your accounts</h2>

      <form class="integrations-auth-redtail__form" @submit.prevent="connect">
        <p>
          Connecting your Redtail account will allow syncing and importing of contacts and groups after linking is
          successful.
        </p>
        <div class="form-group">
          <input
            v-model="username"
            type="text"
            class="form-control integrations-auth-redtail__input"
            name="username"
            placeholder="User Name"
            ref="username"
          />
        </div>
        <div class="form-group">
          <input
            v-model="password"
            type="password"
            class="form-control integrations-auth-redtail__input"
            name="password"
            placeholder="Password"
          />
        </div>

        <button
          type="submit"
          :disabled="!username || !password"
          class="btn btn-lg btn-primary integrations-auth-redtail__submit"
        >
          Sign in to Redtail
        </button>
        <a href="/integrations/catalogue" class="integrations-auth-redtail__cancel">Cancel</a>
      </form>
    </div>
    <integrations-footer></integrations-footer>
  </div>
</template>

<script>
import IntegrationsFooter from '../components/integrations/IntegrationsFooter.vue';
import IntegrationsLoading from '../components/integrations/IntegrationsLoading.vue';

export default {
  name: 'integrations-auth-redtail-page',
  components: {IntegrationsLoading, IntegrationsFooter},
  data() {
    return {
      loading: false,
      username: '',
      password: '',
      success: false,
    };
  },
  props: {
    crm: {
      type: String,
      required: true,
    },
  },
  methods: {
    async connect() {
      this.loading = true;
      try {
        await axios.post('/api/?entity=vessel&action=linkRedtailToVessel', {
          username: this.username,
          password: this.password,
        });
        window.location = '/integrations/catalogue/auth/success?crm=redtail';
      } catch (error) {
        const loginErrors = [400, 401];
        if (loginErrors.includes(error.response.status)) {
          $.notify('Wrong login or password entered', 'error');
        } else {
          $.notify('Something went wrong!', 'error');
        }
        this.loading = false;
      }
    },
  },
};
</script>

<style>
@import '../../sass/templates/integrations/_integrations.scss';
</style>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';
.integrations-auth-redtail {
  max-width: 505px;
  margin: 0 auto;
  padding: 54px 16px;
  &__heading {
    font-size: 28px;
    color: $mine-shaft-color;
    @media (min-width: $breakpoint-sm) {
      font-size: 48px;
    }
  }
  &__form {
    max-width: 400px;
    display: grid;
    margin: 0 auto;
  }
  &__input:-webkit-autofill,
  &__input:-webkit-autofill:hover,
  &__input:-webkit-autofill:focus,
  &__input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  &__submit,
  &__cancel {
    font-weight: 700;
    font-size: 16px;
  }
  &__cancel {
    margin-top: 20px;
    display: block;
    color: $half-baked-color;
    text-align: center;
  }
}
</style>
